import React from 'react';

import DialogCustomer from './RequestDialog';
import { PlusOutlined } from '@ant-design/icons';
import { Button } from 'antd';
const RequestButton = ({ refetch }) => {
  const [open, setOpen] = React.useState(false);
  const onClose = () => {
    refetch();
    setOpen(false);
  };
  const handleOpenDialog = () => {
    setOpen(true);
  };
  return (
    <>
      <Button
        type="primary"
        icon={<PlusOutlined />}
        onClick={handleOpenDialog}
        style={{
          backgroundColor: '#0174CF',
          borderColor: '#0174CF'
        }}>
        Tạo mới
      </Button>
      <DialogCustomer open={open} onClose={onClose} />
    </>
  );
};

export default RequestButton;
